import { Component, Input } from '@angular/core';

@Component({
  selector: 'xt-portal-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: false,
})
export class AvatarComponent {
  @Input() isSmallBubble = true;
  @Input() abbreviation?: string;
  @Input() color = 'primary-light';
  @Input() svgIcon: string | null = null;
  @Input() hasImage = false;
  // @Input() hasIcon;
}
